var map = {
  "./mobile/index.js": [
    "91953",
    9,
    "9598",
    "56737",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "23959",
    "6766",
    "67558"
  ],
  "./desktop/index.js": [
    "6421",
    9,
    "9598",
    "76225",
    "62815",
    "18455",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "23959",
    "6766",
    "20098"
  ],
  "./desktop/index": [
    "6421",
    9,
    "9598",
    "76225",
    "62815",
    "18455",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "23959",
    "6766",
    "20098"
  ],
  "./desktop/PlayerProfile": [
    "34591",
    9,
    "9598",
    "23959",
    "62533"
  ],
  "./mobile/PlayerProfile": [
    "21363",
    9,
    "9598",
    "23959",
    "94129"
  ],
  "./mobile": [
    "91953",
    9,
    "9598",
    "56737",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "23959",
    "6766",
    "67558"
  ],
  "./desktop/PlayerProfile.scss": [
    "88313",
    7,
    "48374"
  ],
  "./desktop": [
    "6421",
    9,
    "9598",
    "76225",
    "62815",
    "18455",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "23959",
    "6766",
    "20098"
  ],
  "./desktop/": [
    "6421",
    9,
    "9598",
    "76225",
    "62815",
    "18455",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "23959",
    "6766",
    "20098"
  ],
  "./mobile/": [
    "91953",
    9,
    "9598",
    "56737",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "23959",
    "6766",
    "67558"
  ],
  "./mobile/PlayerProfile.scss": [
    "19931",
    7,
    "84242"
  ],
  "./desktop/PlayerProfile.js": [
    "34591",
    9,
    "9598",
    "23959",
    "62533"
  ],
  "./mobile/index": [
    "91953",
    9,
    "9598",
    "56737",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "23959",
    "6766",
    "67558"
  ],
  "./mobile/PlayerProfile.js": [
    "21363",
    9,
    "9598",
    "23959",
    "94129"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 84575;
module.exports = __rspack_async_context;
